// extracted by mini-css-extract-plugin
export default {"productImage":"index_productImage__3PCwG","tag":"index_tag__3ykmN"};